import CmsPage, { getCMSPageModel } from "@Libs/contentful/components/CmsPage";
import homePageQuery from "@Libs/contentful/queries/HomePage";
import { updatePageModel } from "@Utils/HomePageHelpers";
import { makeStaticProps, getStaticPaths } from "@wff/libs/i18n/getStatic";

interface HomePropsTypes {
  pageModel: any;
}

const Home = ({ pageModel }: HomePropsTypes) => {
  const { pageContent = {} } = pageModel;

  return (
    <CmsPage
      pageModel={pageModel}
      pageTitle={pageContent.pageTitle ?? ""}
      pageDescription={pageContent.pageDescription ?? ""}
    />
  );
};

const overrideStaticProps = async (props: any) => {
  const { locale } = props;

  // Get the page model content from Contentful
  const pageModel = await getCMSPageModel(homePageQuery, {
    locale,
  });

  // add the returned data to the new model
  const newPageModel = {
    ...pageModel,
    pageContent: {
      ...pageModel?.pageContent,
      templates: {
        ...pageModel?.pageContent?.templates,
        items: (await updatePageModel(pageModel)) ?? null,
      },
    },
  };

  return {
    props: {
      pageModel: newPageModel,
    },
    revalidate: 10, // TODO:- Set revalidation timeout based on the Architecture discussion
  };
};

const getStaticProps = makeStaticProps(["common"], overrideStaticProps);
export { getStaticPaths, getStaticProps };

export default Home;
